import * as React from 'react';

interface Props {
    children: React.Node | Function;
}

export class TimeOptions extends React.PureComponent<Props> {
    get options() {
        const { isStart, isEnd, startTime, endTime } = this.props;

        const quarterHours = ['00', '15', '30', '45'];
        const periods = [' am', ' pm'];

        let startHoursIndex = 0;
        let firstQuarterHoursIndex = 0;
        let endHoursIndex = 23;
        let lastQuarterHoursIndex = quarterHours.length;

        if (isStart && endTime) {
            const [hours, minutes] = endTime.split(':');
            endHoursIndex = Number(hours);
            lastQuarterHoursIndex = quarterHours.indexOf(minutes) + 1;
        }

        if (isEnd && startTime) {
            const [hours, minutes] = startTime.split(':');
            startHoursIndex = Number(hours);
            firstQuarterHoursIndex = quarterHours.indexOf(minutes);
        }

        const times = [];
        for (let i = startHoursIndex; i <= endHoursIndex; i++) {
            const startQuarterHoursIndex =
                i === startHoursIndex ? firstQuarterHoursIndex : 0;
            const endQuarterHoursIndex =
                i === endHoursIndex
                    ? lastQuarterHoursIndex
                    : quarterHours.length;

            for (
                let j = startQuarterHoursIndex;
                j < endQuarterHoursIndex;
                j++
            ) {
                // 24 hour clock
                let time24 = `${i}:${quarterHours[j]}`;
                if (i < 10) {
                    time24 = `0${time24}`;
                }

                // 12 hour clock
                const period = i < 12 ? periods[0] : periods[1];
                const time12 = `${i % 12 || 12}:${quarterHours[j]}${period}`;

                times.push({
                    text: time12,
                    value: time24
                });
            }
        }

        return times;
    }

    render() {
        const { children } = this.props;

        if (typeof children === 'function') {
            return children(this.options);
        }

        return React.cloneElement(children, { options: this.options });
    }
}

export default TimeOptions;
